import { render, staticRenderFns } from "./Component_UserInfo.vue?vue&type=template&id=7afa3eb1&scoped=true&"
import script from "./Component_UserInfo.vue?vue&type=script&lang=js&"
export * from "./Component_UserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afa3eb1",
  null
  
)

export default component.exports